/* eslint-disable react-hooks/exhaustive-deps */
import TableContainer from "../../Components/Table";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  deleteAuditDetails,
  getAuditingList,
  updateSquad,
} from "../../api/common";
import ConfirmBox from "../../Components/ConfirmBox";
import { AUDIT_MODES, ERROR_MESSAGE } from "../../constants";
import SendKickoff from "../../Containers/SendKickoff";
import Delete from "../../icons/Delete.svg?react";
import Edit from "../../icons/Iconedit.svg?react";
import ScheduleKickOff from "../../icons/scheduleKickOff.svg?react";
import SendQuestionnaire from "../../icons/sendQuestionnaire.svg?react";
import ShowAttendeesIcon from "../../icons/showAttendeed.svg?react";
import Info from "../../icons/infoIcon.svg?react";
import {
  calculateOffset,
  decrypt,
  encrypt,
  getAuditLevelLabel,
  getDateFormat,
  getSessionStorage,
  getUniqueAppNames,
} from "../../utils";
import PageContainer from "../PageContainer";
import styles from "./style.module.scss";
import Alert from "../../Components/AlertPopup";
import OrganizationList from "../../Components/OrgModal/OrganizationList";
import AuditInformationModal from "../../Components/InfoModal/AuditInformationModal";

interface AuditInfo {
  id: string;
  auditCode: string;
}

const AuditPlanning = () => {
  const [loading, setLoading] = useState(false);
  const [rowData, setRowData] = useState<[]>([]);
  const [showErrorToast, setShowErrorToast] = useState(false);
  const [showConfirm, setShowConfirm] = useState<boolean>(false);
  const [roleRequestId, setRoleRequestId] = useState<string>("");
  const [squadFlag, setSquadFlag] = useState<boolean>(false);
  const [pageSize, setPageSize] = useState<number>(10);
  const [errorMessage, setErrorMessage] = useState(
    ERROR_MESSAGE.API_ERROR_MESSAGE
  );
  const [showToast, setShowToast] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [selectedAuditId, setSelectedAuditId] = useState<number | null>(null);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [showModal, setShowModal] = useState(false);
  const [auditId, setAuditId] = useState<AuditInfo>({ id: "", auditCode: "" });
  const [isChecked, setIsChecked] = useState(false);
  const [showInfo, setShowInfo] = useState(false);
  const [element, setElement] = useState([]);
  const [userInfo, setUserInfo] = useState<any>();

  const safeJsonParse = (str: string, fallback = null) => {
    try {
      return str ? JSON.parse(str) : fallback;
    } catch {
      return fallback;
    }
  };
  useEffect(() => {
    const encrypted = getSessionStorage("user");
    if (encrypted) {
      const decrypted = decrypt(encrypted);
      setUserInfo(safeJsonParse(decrypted));
    }
  }, []);
  const navigate = useNavigate();

  const navigateTo = (route: string) => {
    navigate(route);
  };

  const columnData = [
    { label: "No", key: "no" },
    { label: "Audit ID", key: "auditCode" },
    {
      label: "Organization",
      key: "orgDetails",
      tdClassname: "text-start wrapTheme",
    },
    {
      label: "Application",
      key: "applicationList",
      tdClassname: "text-start wrapTheme",
    },
    { label: "Theme", key: "theme", tdClassname: "text-start wrapTheme" },
    { label: "Level", key: "auditLevel", tdClassname: "text-center" },

    {
      label: "Duration",
      key: "duration",
      tdClassname: "text-center",
      isMoreField: true,
    },
    { label: "Response Time", key: "responseTime", isMoreField: true },
    {
      label: "Reminder Alert",
      key: "escalationFrequency",
      tdClassname: "text-center",
      isMoreField: true,
    },
    { label: "Actions", key: "actions", disableSortBy: true },
    { label: "Info", key: "info", disableSortBy: true },
  ];
  const MoreFeildsValue = [
    { label: "Duration", value: "duration" },
    {
      label: "Response Time",
      value: "responseTime",
      tdClassname: "text-start",
    },
    { label: "Reminder Alert", value: "escalationFrequency" },
  ];
  const FilterValue = [
    { label: "Auditee", value: "a" },
    { label: "Audit Type", value: "b" },
    { label: "Level", value: "d" },
    { label: "Status", value: "e" },
  ];

  const handleDeleteClick = (auditId: number) => {
    setSelectedAuditId(auditId);
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    if (selectedAuditId !== null) {
      deleteAuditDetails(selectedAuditId)
        .then(() => {
          setLoading(false);
          setShowToast(true);
          fetchData(1);
        })
        .catch((err) => {
          setLoading(false);
          setErrorMessage(ERROR_MESSAGE.API_ERROR_MESSAGE);
          setShowErrorToast(true);
          return;
        });
    }
    setShowDeleteModal(false);
  };
  const handledeleteClose = () => setShowDeleteModal(false);
  const updateSquadFlag = () => {
    setShowConfirm(false);
    setLoading(true);
    updateSquad({ roleRequestId, squad: squadFlag.toString() })
      .then(() => {
        fetchData(1);
      })
      .catch(() => {
        setShowErrorToast(true);
      });
  };

  const showKickoffModal = (id: any, auditCode: string) => {
    setAuditId({ id: id, auditCode: auditCode });
    setShowModal(true);
  };

  useEffect(() => {
    // eslint-disable-next-line
    fetchData(1);
  }, []);
  const handleErrorClose = () => setShowErrorToast(false);
  const handleClose = () => setShowConfirm(false);

  const fetchData = async (pageNumber: number) => {
    setLoading(true);
    const finalSet: any = [];
    getAuditingList(calculateOffset(pageNumber))
      .then((response) => {
        if (response) {
          let i = 1;

          response.forEach((element: any) => {
            finalSet.push({
              ...element,
              no: i,
              createdDate: getDateFormat(element.createdOn, "DD/MM/YYYY"),
              auditMode: AUDIT_MODES[element.auditMode],
              auditLevel: `${getAuditLevelLabel(element.auditLevel)} (${element.auditLevel})`,
              applicationList: getUniqueAppNames(element.organizations),
              theme: element.themes
                .map((data: any) => data?.themeName)
                .join(", "),
              duration: `${element.startDate?.split("-")?.reverse()?.join("/")} - ${element.endDate?.split("-")?.reverse()?.join("/")}`,
              escalationFrequency: element.escalationFrequency ? `${element.escalationFrequency} Days` : "-",
              responseTime: `${element.responseTime} Days`,
              actions: (
                <>
                  <span className="d-flex gap-3 justify-content-center">
                    {!element.kickOffFromDate && !element.kickOffToDate ? (
                      <ScheduleKickOff
                        onClick={() =>
                          showKickoffModal(
                            element.auditingId,
                            element.auditCode
                          )
                        }
                        className={"interactionIcons"}
                        title="Schedule Kickoff"
                        aria-disabled={!element.isKickoffRequired}
                      />
                    ) : (
                      <ShowAttendeesIcon className={"attendeesIcons"} />
                    )}
                    {
                      <>
                        <SendQuestionnaire
                          className={"questionnaireIcons"}
                          title="Send Questionnaire"
                          aria-disabled={
                            element.isKickoffRequired &&
                            !element.kickOffFromDate &&
                            !element.kickOffToDate
                          }
                          onClick={() =>
                            navigateTo(
                              "/audit-scheduled/select-question/" +
                              encrypt(parseInt(element.auditingId)) +
                              "/" +
                              encrypt(
                                getAuditLevelLabel(element.auditLevel)
                              ) +
                              "/" +
                              encrypt(element.auditCode) // Encrypted auditCode string
                            )
                          }
                        />
                      </>
                    }
                    <Edit
                      title="Edit"
                      className={styles.iconStyleActions}
                      onClick={() =>
                        navigate("/audit-scheduled/edit/" + element.auditingId)
                      }
                    />
                    <Delete
                      title="Delete"
                      className={styles.iconStyleActions}
                      onClick={() => handleDeleteClick(element.auditingId)}
                    />
                  </span>
                </>
              ),
              orgDetails: (
                <OrganizationList
                  title="Organization Under Audit ID:"
                  auditCode={element.auditCode}
                  organizations={element.organizations}
                />
              ),
              info: (
                <span>
                  <Info
                    className={styles.iconStyleActions}
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowInfo(true);
                      setElement(element);
                    }}
                  />
                </span>
              ),
            });
            i++;
          });
        }
        setRowData(finalSet);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        setShowErrorToast(true);
      });
  };
  const indexOfLastItem = currentPage * pageSize;
  const indexOfFirstItem = indexOfLastItem - pageSize;
  const currentItems = rowData.slice(indexOfFirstItem, indexOfLastItem);
  const handlePageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const handlePageSizeChange = (newLimit: number) => {
    setPageSize(newLimit);
    setCurrentPage(1); // Reset to first page on limit change
  };

  return (
    <PageContainer>
      <div className={styles.title}> Audit Scheduled</div>

      <div className={styles.actionItem}>
        <div className={styles.tabs}></div>
      </div>

      <div>
        <TableContainer
          columnData={columnData}
          rowData={currentItems}
          CheckboxText={"Show My Team"}
          totalResult={rowData.length}
          title={"List of Audit Scheduled"}
          enableMoreFeilds={true}
          enableFilter={true}
          itemsPerPage={pageSize}
          MoreFeildsValue={MoreFeildsValue}
          FilterValue={FilterValue}
          buttonOnClick={() => {
            navigateTo("/audit-overview/add");
          }}
          isCheckboxChecked={isChecked}
          onCheckboxToggle={(checked) => setIsChecked(checked)}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          onPageNoChange={handlePageChange}
          onPageLimitChange={handlePageSizeChange}
          checkBox={false}
          showLoading={loading}
          noRecordMessage={"There are no audits in the Scheduled stage."}
        />
      </div>
      <Alert
        show={showErrorToast}
        onClose={handleErrorClose}
        type="error"
        message={ERROR_MESSAGE.API_ERROR_MESSAGE}
      />
      <ConfirmBox
        message="Are you sure you want to update?"
        handleClose={handleClose}
        show={showConfirm}
        onConfirm={updateSquadFlag}
      />
      <ConfirmBox
        message="Are you sure you want to delete this audit?"
        handleClose={handledeleteClose}
        show={showDeleteModal}
        onConfirm={confirmDelete}
      />
      <Alert
        show={showToast}
        onClose={() => {
          setShowToast(false);
          navigate("/audit-scheduled");
        }}
        message={"The audit plan has been Deleted successfully!!"}
      />
      <SendKickoff
        userInfo={userInfo}
        showModal={showModal}
        auditId={auditId}
        onClose={() => {
          setShowModal(false);
        }}
        tableReload={() => fetchData(1)}
      />
      <AuditInformationModal
        element={element}
        show={showInfo}
        onHide={() => setShowInfo(false)}
      />
    </PageContainer>
  );
};

export default AuditPlanning;
